import { Feature } from '../api/types'

const getFeature = (features: Feature[], feature: Feature['name']) =>
  features.find((item) => item.name === feature)

const hasPermission = (permissions: Feature['grants'], requiredPermissions: Feature['grants']) =>
  permissions.some((p) => requiredPermissions.includes(p))

export { getFeature, hasPermission }
